import * as React from 'react'

export const PageContext = React.createContext<boolean>(false)

interface Props {
  isLoading: boolean
}

const Provider: React.FC<React.PropsWithChildren<Props>> = ({ children, isLoading }) => (
  <PageContext.Provider value={isLoading}>{children}</PageContext.Provider>
)

export default Provider
